module.exports = __webpack_public_path__ + "static/SoundMate@2x-e61ffaeefabb17db26f6c8f6fde2193f.jpg";